/** @format */

import moment from 'moment';

/**
 * Las fechas de las OT vienen en formatos mezclados:
 * - workOrder.date: 'YYYY-MM-DD HH:mm' (nuevas) o 'DD/MM/YY' (viejas)
 * - workOrder.fecha: 'YYYY-MM-DD'
 * - lodging.start: ISO
 * Ordenar con moment(valor) a secas devolvia Invalid Date en las viejas.
 */
const FORMATOS = [
	'YYYY-MM-DD HH:mm',
	'YYYY-MM-DDTHH:mm:ss.SSSZ',
	'YYYY-MM-DD',
	'DD/MM/YY',
	'DD/MM/YYYY',
];

export const parseFechaOT = valor => {
	if (!valor) return null;
	const fecha = moment(valor, FORMATOS, true);
	if (fecha.isValid()) return fecha;
	const libre = moment(valor);
	return libre.isValid() ? libre : null;
};

export const milisegundos = valor => {
	const fecha = parseFechaOT(valor);
	return fecha ? fecha.valueOf() : 0;
};

/** Fecha corta para la tabla; devuelve '—' si no se pudo interpretar */
export const textoFecha = (valor, formato = 'DD/MM/YYYY') => {
	const fecha = parseFechaOT(valor);
	return fecha ? fecha.format(formato) : '—';
};

export const textoFechaHora = valor => textoFecha(valor, 'DD/MM/YYYY HH:mm');
